import React from 'react';
import './openingBalance.css';
import Breadcrumb from '../../../components/Breadcrumb';

function OpeningBalance() {
  const breadcrumbItems = [
    { label: 'Dashboard', href: '/' },
    { label: 'Opening Balance' },
  ];
  return (
    <div>
      <Breadcrumb items={breadcrumbItems} />
      <div className="card">
        <div className="card-body">
          <h1>OpeningBalance</h1>
        </div>
      </div>
    </div>
  );
}

export default OpeningBalance;
